/**
 * Description: File containing constants for audit tool website
 */
export const BATCH_SIZE = 5
export const AMZN_DOMAIN = {
  1: "www.amazon.com",
  3: "www.amazon.co.uk",
  4: "www.amazon.de",
  5: "www.amazon.fr",
  6: "www.amazon.co.jp",
  7: "www.amazon.ca",
  35691: "www.amazon.it",
  44551: "www.amazon.es",
  44571: "www.amazon.in",
  111172: "www.amazon.com.au",
  328451:  "www.amazon.nl",
  338801:  "www.amazon.ae",
  338811:  "www.amazon.sa",
  338851: "www.amazon.com.tr",
  526970:  "www.amazon.com.br",
  771770: "www.amazon.com.mx",
  623225021: "www.amazon.eg",
  679831071: "www.amazon.com.be",
  680844071: "www.amazon.co.za",
  104444012: "www.amazon.sg",
  704403121: "www.amazon.se",
  712115121: "www.amazon.pl",
  753556201: "www.amazon.ie",
}
export const MARKETPLACES = [
  {
    "label": "Australia - 111172",
    "id": "111172"
  },
  {
    "label": "Japan - 6",
    "id": "6"
  },
  {
    "label": "Singapore - 104444012",
    "id": "104444012"
  },
  {
    "label": "Belgium - 679831071",
    "id": "679831071"
  },
  {
    "label": "Egypt - 623225021",
    "id": "623225021"
  },
  {
    "label": "France - 5",
    "id": "5"
  },
  {
    "label": "Germany - 4",
    "id": "4"
  },
  {
    "label": "India - 44571",
    "id": "44571"
  },
  {
    "label": "Ireland - 753556201",
    "id": "753556201"
  },
  {
    "label": "Italy - 35691",
    "id": "35691"
  },
  {
    "label": "Netherlands - 328451",
    "id": "328451"
  },
  {
    "label": "Poland - 712115121",
    "id": "712115121"
  },
  {
    "label": "Saudi Arabia - 338811",
    "id": "338811"
  },
  {
    "label": "South Africa - 680844071",
    "id": "680844071"
  },
  {
    "label": "Spain - 44551",
    "id": "44551"
  },
  {
    "label": "Sweden - 704403121",
    "id": "704403121"
  },
  {
    "label": "Turkey - 338851",
    "id": "338851"
  },
  {
    "label": "United Arab Emirates - 338801",
    "id": "338801"
  },
  {
    "label": "United Kingdom - 3",
    "id": "3"
  },
  {
    "label": "Brazil - 526970",
    "id": "526970"
  },
  {
    "label": "Canada - 7",
    "id": "7"
  },
  {
    "label": "Mexico - 771770",
    "id": "771770"
  },
  {
    "label": "United States - 1",
    "id": "1"
  },
]

export const UI_DATE_FORMAT = "YYYY-MM-DD"


// WEBPACK FOOTER //
// ./src/components/constants.jsx